<template>
    <div class="telephony-tab">
        <v-row align="center" class="ma-0 mt-6 mb-4" v-if="checkRole(project.id, 'project:connector:edit')">
            <v-spacer></v-spacer>
            <ChangeViewBtn
                :value="telephonyView"
                @input="updateTelephonyView"
                :cacheKey="'telephonyView'"
            ></ChangeViewBtn>
        </v-row>
        <div v-if="telephonyView === 'cards'" class="cards-grid mt-4">
            <component
                v-for="card in allTelephonyCards"
                :is="card.isActive ? 'ConnectorCard' : 'InactiveTelephonyCard'"
                :key="card.key"
                :connector="card.connector"
                :connectorType="card.connectorType"
                :projectId="project.id"
                :selectedConnectors="selectedConnectors"
                :loading="card.loading"
                @openConnectorSettings="handleOpenConnectorSettings"
                @deleteConnector="handleDeleteConnector"
            ></component>
        </div>
        <ConnectorsListView
            v-if="telephonyView === 'list'"
            :allTelephonyCards="allTelephonyCards"
            :value="selectedConnectors"
            @input="handleSelectedConnectorsUpdate"
            @openConnectorSettings="handleOpenConnectorSettings"
            @deleteConnector="handleDeleteConnector"
        ></ConnectorsListView>
    </div>
</template>

<script>
import { checkRole } from '../../helpers/roles'
import ChangeViewBtn from '@/components/buttons/ChangeViewBtn'
import ConnectorCard from './ConnectorCard'
import InactiveTelephonyCard from './InactiveTelephonyCard.vue'
import ConnectorsListView from './ConnectorsListView'

export default {
    name: 'TelephonyTab',
    components: {
        ChangeViewBtn,
        ConnectorCard,
        InactiveTelephonyCard,
        ConnectorsListView,
    },
    props: {
        project: {
            type: Object,
            required: true,
        },
        telephonyConnectors: {
            type: Array,
            required: true,
        },
        allTelephonyCards: {
            type: Array,
            required: true,
        },
        selectedConnectors: {
            type: Array,
            default: () => [],
        },
        telephonyView: {
            type: String,
            default: 'cards',
        },
    },
    methods: {
        checkRole,
        updateTelephonyView(value) {
            this.$emit('update:telephonyView', value)
            this.$emit('update:selectedConnectors', [])
        },
        handleSelectedConnectorsUpdate(value) {
            this.$emit('update:selectedConnectors', value)
        },
        handleOpenConnectorSettings(connectorId) {
            this.$emit('openConnectorSettings', connectorId)
        },
        handleDeleteConnector(connectorId) {
            this.$emit('deleteConnector', connectorId)
        },
    },
}
</script>

<style scoped>
.telephony-tab {
    margin-top: 16px;
}

.cards-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    width: 100%;
}

/* только корень карточки — не трогаем иконки/кнопки внутри */
.cards-grid >>> > .connector-card {
    width: 100% !important;
    max-width: none !important;
    box-sizing: border-box;
}

@media (max-width: 1100px) {
    .cards-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 720px) {
    .cards-grid {
        grid-template-columns: minmax(0, 1fr);
    }
}
</style>

